import Body from "./body/Body";

const MainPage = () => {
    return(
        <div style={{display:"flex", justifyConteng:"center"}}>
            <Body/>
        </div>
    )
}

export default MainPage;